import { Controller } from '@hotwired/stimulus'
import * as analytics from '../../libs/analytics'

// Captures one event as the element arrives, so a server response can report
// what just happened from the browser: PostHog only shows a survey on an
// event the browser captured.
export default class extends Controller {
  static values = {
    name: String,
    properties: Object
  }

  connect() {
    analytics.capture(this.nameValue, this.propertiesValue)
  }
}
